<template>
  <div>
    <LessonHeader :hide-display="'hide_content'" />
    <div class="browser-container">
      <div class="content">
        <el-row class="description">
          <div class="row-center mt40">
            <h2 v-if="jwtError && jwtError.name === 'NotBeforeError'" v-html="nbfMsg"></h2>
            <div v-else>
              <h2 v-html="generalTitle"></h2>
              <div class="tal mt20" v-html="generalMsg"></div>
            </div>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import LessonHeader from '@/components/Lesson/Header/LessonHeader';

export default {
  components: {
    LessonHeader
  },
  data() {
    return {
      generalMsg: this.$t('errorView.generalMsg'),
      generalTitle: this.$t('errorView.generalTitle'),
      nbfMsg: this.$t('errorView.nbfMsg')
    };
  },
  beforeMount: async function() {
    this.setLanguage();
    this.setContent();
  },
  computed: {
    ...mapState(['jwtError', 'lessonToken', 'unverifiedPayload'])
  },
  methods: {
    setContent() {
      this.generalMsg = this.$t('errorView.generalMsg');
      this.generalTitle = this.$t('errorView.generalTitle');
      this.nbfMsg = this.$t('errorView.nbfMsg');
    },
    setLanguage() {
      this.$i18n.locale = this.unverifiedPayload && this.unverifiedPayload.a === 's' ? 'ja' : 'en';
    }
  }
};
</script>

<style scoped>
.browser-container {
  margin-top: 20px;
}
.description {
  font-size: 15px;
  line-height: 25px;
  text-align: center;
}
.mt20 {
  margin-top: 20px;
}
.mt40 {
  margin-top: 40px;
}
.tal {
  text-align: left;
}
h2 {
  font-size: 23px;
  line-height: 30px;
}
</style>
